import SetupSecurityQuestions from './SetupSecurityQuestionsContainer';

export default SetupSecurityQuestions;